import React from 'react';
import { NewDashboardHeader } from '../../components/NewDashboardHeader';
import { Footer } from '../../components/Footer';
import { AppUser, UserRole } from '../../types';
import { CIEN_CUADRAS_BLUE } from '../../constants';
import { InformationCircleIcon } from '../../components/Icons';

interface NoRoleHomeViewProps {
  onLogout: () => void;
  firebaseUser?: { uid?: string; email?: string; displayName?: string } | null;
  appUser: AppUser | null;
  newlyAddedRange?: { startDate: Date; endDate: Date };
}

export const NoRoleHomeView: React.FC<NoRoleHomeViewProps> = ({ onLogout, firebaseUser, appUser, newlyAddedRange }) => {
  const isSinRol = !appUser || appUser.role === UserRole.SIN_ROL;
  const welcomeMessage = `Bienvenido, ${appUser?.displayName || firebaseUser?.displayName || 'Usuario'}`;

  const message1 = isSinRol
    ? 'Actualmente, tu cuenta está pendiente de asignación de rol.'
    : `Tu rol (${appUser?.role}) no tiene un panel de control asignado.`;

  const message2 = isSinRol
    ? 'Un administrador revisará tu registro y te asignará los permisos correspondientes pronto. Si tienes alguna pregunta, por favor, contacta con el soporte.'
    : 'Por favor, contacta a un administrador para que verifique la configuración de tu cuenta. Si crees que esto es un error, intenta recargar la página.';

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col" style={{ fontFamily: 'Inter, "Noto Sans", sans-serif' }}>
      <NewDashboardHeader onLogout={onLogout} appUser={appUser} isNewlyAddedMode={!!newlyAddedRange} />
      <main className="flex-grow max-w-3xl mx-auto space-y-6 p-4 md:p-8 w-full flex flex-col items-center justify-center">
        <div className="bg-white p-8 rounded-lg shadow-xl text-center">
          <InformationCircleIcon className="w-16 h-16 text-sky-500 mx-auto mb-4" />
          <h1 className="text-2xl font-bold mb-2" style={{ color: CIEN_CUADRAS_BLUE }}>
            {welcomeMessage}
          </h1>
          {appUser?.role && (
            <p className="text-md font-semibold text-orange-600 mb-4" aria-live="polite">
              Rol actual: {appUser.role}
            </p>
          )}
          <p className="text-gray-700 mb-2">{message1}</p>
          <p className="text-gray-600 text-sm mb-6">{message2}</p>
          <button
            onClick={onLogout}
            className="px-6 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
          >
            Cerrar Sesión
          </button>
        </div>
      </main>
      <Footer />
    </div>
  );
};
